module.exports = __webpack_public_path__ + "resources/img/sp_mypage.c2317f20c817017e42c03074125c882d.png";